import { AllCustomersResponseModel, CustomersDropDownDataResponseModel, CustomersResponseModel } from '@gtpl/shared-models/masters';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';

import { CustomersService } from './customers.service';
import { CustomerRequest } from './dto/customer.request';
import { CustomersDTO } from './dto/customers.dto';
import { UserRequestDto } from './dto/user-logs-dto';
@ApiTags('Customers')
@Controller('customers')
export class CustomersController {
    constructor(
        private customersService: CustomersService,
        private readonly applicationExceptionhandler: ApplicationExceptionHandler,

    ) { }
    /**
     * creates or updates a value of Customers
     * @param CustomersDto Customers DTO
     * @returns CustomersResponse
     */
    @Post('/createCustomers')
    async createCustomers(@Body() customersDTO: CustomersDTO, isUpdate: boolean = false): Promise<CustomersResponseModel> {
        try {
            return await this.customersService.createCustomer(customersDTO, false);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(CustomersResponseModel, error)
        }
    }
    /**
     *  creates or updates a value of Customers
     * @param customersDTO 
     * @param request 
     */
    @Post('/updateCustomer')
    async updateCustomer(@Body() customersDTO: CustomersDTO): Promise<CustomersResponseModel> {
        try {
            return await this.customersService.createCustomer(customersDTO, true);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(CustomersResponseModel, error)
        }
    }

    /**
     * get All Customers Details
     * @param request 
     */
    @Post('/getAllCustomers')
    async getAllCustomers(@Body() req?: UserRequestDto): Promise<AllCustomersResponseModel> {
        try {
            return await this.customersService.getAllCustomers(req);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(AllCustomersResponseModel, error)
        }
    }
    @Post('/getAllActiveCustomers')
    async getAllActiveCustomers(@Req() request: Request): Promise<AllCustomersResponseModel> {
        try {
            return await this.customersService.getAllActiveCustomers();
        } catch (error) {
            return this.applicationExceptionhandler.returnException(AllCustomersResponseModel, error)
        }
    }

    @Post('/getCustomerDataById')
    async getCustomerDataById(@Body() customerRequest:CustomerRequest,@Req() request: Request): Promise<CustomersResponseModel> {
        try {

        return await this.customersService.getCustomerDataById(customerRequest);
        } catch (error) {
            
            return this.applicationExceptionhandler.returnException(CustomersResponseModel, error)
        }
    }

    /**
     * Activate or Deactivate Customer
     * @param customerReq 
     */
    @Post('/activateOrDeactivateCustomer')
    async activateOrDeactivateCustomer(@Body() customerReq: CustomerRequest): Promise<CustomersResponseModel> {
        try {
            return await this.customersService.activateOrDeactivateCustomer(customerReq);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CustomersResponseModel, err);
        }
    }

    /**
     * get All Customers Details
     * @param request 
     */
    // @Post('/getActiveCustomersDropDownData')
    // async getActiveCustomersDropDownData(): Promise<CustomersDropDownDataResponseModel> {
    //     try {
    //         return await this.customersService.getActiveCustomersDropDownData();
    //     } catch (error) {
    //         return this.applicationExceptionhandler.returnException(CustomersDropDownDataResponseModel, error)
    //     }
    // }
}
